import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import type { MongoAtlasConnectRestoreProjectState } from './connectMongoAtlasRestoreProject';
import { mongoAtlasConnectRestoreProjectFlow } from './mongoAtlasRestoreConnectFlows';

export function MongoAtlasConnectRestoreWizard({
  onCreated,
}: {
  onCreated: () => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async () => {
    await onCreated();
    return true;
  };

  return (
    <Wizard<MongoAtlasConnectRestoreProjectState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[mongoAtlasConnectRestoreProjectFlow]}
      title='Connect restore project'
      initialState={{
        connectMethod: 'terraform',
        projectId: '',
        apiPublicKey: '',
        apiPrivateKey: '',
        restoreAccount: undefined,
      }}
    />
  );
}
